module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-p-130x130q80-e3ad21ab3f0075790b386c08b091acc3.jpg";